export const GIFTCARD_REPORT = {
  Report: '/report/giftcard',
  Export: '/report/giftcard/export',
};
